<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
	<mat-icon class="mep-dialog-header-icon" cdkDragHandle svgIcon="mep_bug_icon"></mat-icon>
	<div class="header-text">
		<span class="mep-dialog-title">{{ "mep.components.bug-report.your-feedback-header" | translate }} </span>
	</div>

	<div class="dialog-container">
		<div class="dialog-text">
			<span class="mep-text-big-bold">{{ "mep.components.bug-report.your-subject" | translate }}</span>
		</div>
		<div class="subject-list">
			<mat-button-toggle-group class="mep-toggle-group">
				@for (subject of subjects; track subject) {
					<mat-button-toggle
						(click)="changeSubject(subject.name)"
						[checked]="subject.selected"
						[ngClass]="subject.selected ? 'button-selected' : ''"
					>
						<span>{{ subject.name }}</span>
					</mat-button-toggle>
				}
			</mat-button-toggle-group>
		</div>
	</div>

	<div class="dialog-container">
		<div class="dialog-text">
			<span class="mep-text-big-bold">{{ "mep.components.bug-report.your-feedback" | translate }}</span>
		</div>
		<mat-form-field class="mep-dialog-big-container">
			<textarea
				#feedbackInput
				class="mep-input"
				matInput
				[disabled]="!subjectSelected"
				[(ngModel)]="summary"
				name="description"
			></textarea>
		</mat-form-field>
	</div>

	<div class="dialog-container">
		<div class="dialog-text">
			<span class="mep-text-big-bold">{{ "mep.components.bug-report.your-attachment" | translate }}</span>
			<p class="attachment-hint">{{ "mep.components.bug-report.attachment-limit" | translate: {maxSize: maxAttachmentSizeMiB} }}</p>
		</div>
		<div class="mep-dialog-input-container">
			<app-file-drag-drop
				class="mep-drag-drop"
				[selectedFile]="attachment"
				(fileDropped)="onFileChosen($event)"
			></app-file-drag-drop>
			@if (attachment) {
				<button type="button" class="mep-btn-big-blue-secondary remove-attachment" (click)="removeAttachment()">
					<mat-icon class="material-symbols-rounded" aria-hidden="true">delete_outline</mat-icon>
					{{ "mep.components.bug-report.remove-attachment" | translate }}
				</button>
			}
		</div>
	</div>

	<div class="mep-dialog-actions">
		<button class="mep-btn-dialog-secondary" (click)="dialogRef.close()" appEscapeHotkey>
			{{ "mep.components.bug-report.cancel" | translate }}
		</button>
		<button [disabled]="summary.length <= 0 || isSending" class="mep-btn-dialog-primary" (click)="sendFeedback()">
			{{ "mep.components.bug-report.send" | translate }}
		</button>
	</div>
</div>
